let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d1Lrf")).then(() => parcelRequire('6RK0u'));